import { render } from "./NotFound.vue?vue&type=template&id=6a1e18d0&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=6a1e18d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a1e18d0"]])

export default __exports__